export const SsoModalConstant = {
    //modal button values
    SUBMIT: 'SUBMIT',
    CANCEL: 'CANCEL'
}